import { useState } from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";

import "../styles/Contact.css";

import CustomAlert from "../components/CustomAlert";

function Contact() {
  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    subject: "",
    message: "",
  });

  const [alert, setAlert] = useState({ message: "", visible: null });
  const [disableSubmit, setDisableSubmit] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableSubmit(true);
    try {
      // Update with your AWS API Gateway endpoint URL
      const response = await fetch(
        "https://wz7li0gjo4.execute-api.us-east-2.amazonaws.com/v1/contact-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const textResponse = await response.text(); // Get the raw response text
      console.log(textResponse); // Log the raw response for debugging

      if (response.ok) {
        setAlert({ message: "Email sent successfully!", visible: true });
        setFormData({
          fname: "",
          lname: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setAlert({ message: "Failed to send email.", visible: true });
      }
    } catch (error) {
      setAlert({ message: "Error sending email.", visible: true });
    }
    setDisableSubmit(false);
  };

  useEffect(() => {
    if (alert.visible) {
      const timer = setTimeout(() => {
        setAlert({ message: "", visible: null });
      }, 10000);

      return () => clearTimeout(timer);
    }
  }, [alert]);

  return (
    <>
      <Helmet>
        <title>Contact Jax Utilities Management | Get in Touch</title>
        <meta
          name="description"
          content="Contact Jax Utilities Management for your site development and underground utilities needs in the North East Florida area."
        />
        <meta
          property="og:title"
          content="Contact Jax Utilities Management | Get in Touch"
        />
        <meta
          property="og:description"
          content="Reach out to Jax Utilities Management for your site development and utilities needs in Jacksonville."
        />
        <meta
          property="og:image"
          content="https://jum-email-signature.s3.us-east-2.amazonaws.com/JAXUM+Logo+(bold+est).png"
        />
        <meta property="og:url" content="https://www.jaxum.com/contact" />
        <link rel="canonical" href="https://www.jaxum.com/contact" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Contact Jax Utilities Management | Get in Touch"
        />
        <meta
          name="twitter:description"
          content="Contact Jax Utilities Management for your site development and underground utilities needs in the North East Florida area."
        />
        <meta
          name="twitter:image"
          content="https://jum-email-signature.s3.us-east-2.amazonaws.com/JAXUM+Logo+(bold+est).png"
        />
      </Helmet>

      {alert.message && (
        <CustomAlert message={alert.message} visible={alert.visible} />
      )}
      <div className="contact-container">
        <div className="contact-form">
          <div className="contact-title">
            <h1>CONTACT</h1>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="input-container">
              <label>First name:</label>
              <input
                className="input-box"
                type="text"
                id="fname"
                name="fname"
                required
                value={formData.fname}
                onChange={handleChange}
              />
            </div>
            <div className="input-container">
              <label>Last name:</label>
              <input
                className="input-box"
                type="text"
                id="lname"
                name="lname"
                required
                value={formData.lname}
                onChange={handleChange}
              />
            </div>
            <div className="input-container">
              <label>Email:</label>
              <input
                className="input-box"
                type="email"
                id="email_input"
                name="email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="input-container">
              <label>Subject:</label>
              <input
                className="input-box"
                type="text"
                id="subject"
                name="subject"
                required
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div className="input-container">
              <label>Message:</label>
              <textarea
                className="input-box textarea"
                type="text"
                id="message"
                name="message"
                required
                value={formData.message}
                onChange={handleChange}
              />
            </div>

            <div className="submit-button">
              {disableSubmit ? (
                <div className="submitting-wait-container">
                  <p className="submitting-wait">Submitting...</p>
                </div>
              ) : (
                <input type="submit" value="Submit" disabled={disableSubmit} />
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Contact;
